import React from 'react';
import { useViewChangeTracker } from '../../../hooks/useViewChangeTracker';
import AssociationAnalyticsDashboard from '../GdaAnalytics/AssociationAnalyticsDashboard';

function SummaryGDAGraphs({ source, view, names }) {
  useViewChangeTracker('SummaryGDAGraphs', view, 'graph');

  return <AssociationAnalyticsDashboard associationTab="GDA" source={source} view={view} names={names} />;
}

export default React.memo(SummaryGDAGraphs);
